/**
 * Single source of truth for items/services that are not yet
 * purchasable. Used by /view-plans, individual service pages and the
 * CartContext guard so a "Coming Soon" item cannot be added from any
 * surface in the app (including cart/checkout).
 */
export const COMING_SOON_IDS: ReadonlySet<string> = new Set([
  // /view-plans assessment row IDs
  "assess-lactate",
  "assess-lactate-vo2",
  "assess-perf-diag",
  // Individual service page IDs
  "lactate-test-single",
  "vo2max-test-single",
  "vo2-max-single",
  "performance-diagnostic-single",
  "lactate-vo2-combo",
]);

export const COMING_SOON_SERVICE_SLUGS: ReadonlySet<string> = new Set([
  "lactate-test",
  "vo2-max",
  "performance-diagnostic",
]);

export const isComingSoonId = (id: string): boolean => COMING_SOON_IDS.has(id);
export const isComingSoonSlug = (slug: string): boolean =>
  COMING_SOON_SERVICE_SLUGS.has(slug);
